import { useQuery } from "@tanstack/react-query";
import httpClient from "@/config/axios";
import { useGroupStore } from "@/store/groupStore";
import { useIsAdmin } from "../useAuth";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";

/**
 * Group Id 별로 캐싱함,
 * 이 엔드포인트는 Group ID 굳이 필요 없음
 *
 */

export type RosterConfigVersionsResponse = {
  config_id: number;
}[];

export function useRosterConfigVersionsQuery() {
  const { selectedGroupId } = useGroupStore();
  const isAdmin = useIsAdmin();

  const effectiveGroupId = isAdmin
    ? (selectedGroupId ?? selectedGroupId ?? "")
    : undefined;

  return useQuery({
    queryKey: QUERY_KEYS.config.rosterConfigVersions(effectiveGroupId ?? ""),
    queryFn: () =>
      httpClient.get<RosterConfigVersionsResponse>(
        `/roster/config/versions?group_id=${effectiveGroupId}`
      ),
    staleTime: 5 * 60 * 1000,
    retry: 1,
    retryDelay: 1000,
  });
}
